export const EUR = { value: 'EUR', symbol: '€' }
export const USD = { value: 'USD', symbol: '$' }
export const RUB = { value: 'RUB', symbol: '₽' }

export const CURRENCY_SYMBOLS_MAP = {
  [EUR.value]: EUR.symbol,
  [USD.value]: USD.symbol,
  [RUB.value]: RUB.symbol
}
